import { render } from "./App.vue?vue&type=template&id=eae07184"
const script = {}

import exportComponent from "/github/workspace/src/mealplanner-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__